import * as React from 'react';
import { compose } from 'redux';
import { asPage } from '../../utils/wrappers/asPage';
import { LProps, withLocalization } from '../../utils/wrappers';
import Footer from '../../shared/Footer';
import RouteLink from '../../shared/RouteLink';
import { Routes } from '../../utils/routerHelper';
import { CCSF_CONTACT_EMAILS, CCSF_CONTACT_MAILTO } from '../../utils/ccsfContacts';

class AccessibilityPage extends React.Component<LProps<{}>> {
  private previousTitle = '';

  public componentDidMount() {
    this.previousTitle = document.title;
    document.title = 'Accessibility | Sustainability Challenge';
  }

  public componentWillUnmount() {
    if (this.previousTitle) {
      document.title = this.previousTitle;
    }
  }

  public render() {
    const { t } = this.props;
    return (
      <div className="cc__page__column_content">
        <div className="cc__white_box" style={{ maxWidth: 720, margin: '0 auto' }}>
          <h1>{t('Accessibility')}</h1>
          <p>
            {t('The City and County of San Francisco Sustainability Challenge aims to make this website usable by everyone, including people with disabilities.')}
          </p>
          <p>
            {t('We are working toward WCAG 2.1 Level AA as the baseline for state and local government web content under the DOJ Title II web accessibility rule, and we follow applicable San Francisco web accessibility guidance.')}
          </p>
          <h2>{t('Report an accessibility problem')}</h2>
          <p>
            {t('If you have trouble using any part of this Challenge site, email')}{' '}
            <a href={CCSF_CONTACT_MAILTO} style={{ textDecoration: 'underline', fontWeight: 700 }}>
              {CCSF_CONTACT_EMAILS}
            </a>
            {t(' with the page URL, what you were trying to do, and the assistive technology or browser you used if you know it.')}
          </p>
          <p>
            {t('We will review reports and work to provide assistance or a fix.')}
          </p>
          <p>
            <RouteLink route={Routes.Dashboard}>{t('Back to Challenge home')}</RouteLink>
          </p>
        </div>
        <Footer />
      </div>
    );
  }
}

export default asPage({ requiresCompetitionStart: false })(compose(
  withLocalization('accessibility')
)(AccessibilityPage));
